import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../../utils/request';
import { METHOD_POST } from '../../../constants/api';
import { setOrderedParts } from '../../../actions/coilovers/orderedParts/patchOrderedParts';

const correctionOrderedParts = createAsyncThunk('orderedParts/patchOrderedParts',
  async ({ _id, formData } = {}, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await authSet(METHOD_POST, `/co/ordered_parts/${_id}/correction`, formData);
      dispatch(setOrderedParts(data));
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default correctionOrderedParts;
